export default __webpack_public_path__ + "static/media/favicon.6f0a4f4a.ico";